var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.414 19.6869L21.437 10.6639L19.141 8.36694L12.414 15.0389L8.914 11.4839L6.562 13.8349L12.414 19.6869ZM23.898 23.8979C21.164 26.6319 17.864 27.9999 14 27.9999C10.135 27.9999 6.836 26.6319 4.101 23.8979C1.367 21.1639 0 17.8649 0 13.9999C0 10.1349 1.367 6.83494 4.101 4.10094C6.836 1.36694 10.135 -6.10352e-05 14 -6.10352e-05C17.864 -6.10352e-05 21.164 1.36694 23.898 4.10094C26.633 6.83494 28 10.1349 28 13.9999C28 17.8649 26.633 21.1639 23.898 23.8979Z",
  fill: "white"
})));
export default SvgIconTick;